import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Skeleton } from '@/components/ui/skeleton';
import { Trophy } from 'lucide-react'; // Example icon

// Define the structure for badge information
export interface BadgeInfo {
  id: string; // Unique identifier for the badge
  name: string;
  icon: string; // Emoji or icon component
  description: string;
  earned: boolean; // Whether the user has earned this badge
  pointsRequired?: number; // Optional: Points needed for the badge
}

interface EarnedBadgesCardProps {
  badges: BadgeInfo[];
  isLoading: boolean;
  title?: string;
  description?: string;
}

export const EarnedBadgesCard: React.FC<EarnedBadgesCardProps> = ({
  badges,
  isLoading,
  title = "Your Badges",
  description = "Milestones you've achieved."
}) => {

  const earnedBadges = badges.filter(badge => badge.earned);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trophy className="h-5 w-5" /> {/* Generic Badge Icon */}
          {title}
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-3">
            <Skeleton className="h-8 w-3/4" />
            <Skeleton className="h-8 w-1/2" />
          </div>
        ) : earnedBadges.length > 0 ? (
          <div className="space-y-3">
            {earnedBadges.map((badge) => (
              <div key={badge.id} className="flex items-center gap-3 p-2 border rounded-lg">
                <span className="text-2xl">{badge.icon}</span>
                <div>
                  <p className="font-semibold">{badge.name}</p>
                  <p className="text-sm text-muted-foreground">{badge.description}</p>
                </div>
              </div>
            ))}
            {/* Optional: Add a link/button to see all badges */}
            {/* <Button variant="link" size="sm" className="mt-2 p-0 h-auto">View all badges</Button> */}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">
            Keep exploring and spending to earn your first badge!
          </p>
        )}
      </CardContent>
    </Card>
  );
}; 